"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatSelectorOptions = void 0;

var _constants = require("./constants");

var _designLanguage = require("@doordash/design-language");

var nameLocaleSorter = function nameLocaleSorter() {
  var preferredCountryCodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Most preferred codes to have the highest index
  var preferredCountryCodesLookup = preferredCountryCodes.reverse();
  return function (a, b) {
    var aPreferredIndex = preferredCountryCodesLookup.indexOf(a.value);
    var bPreferredIndex = preferredCountryCodesLookup.indexOf(b.value);

    if (aPreferredIndex !== -1 || bPreferredIndex !== -1) {
      var aNormalized = aPreferredIndex + 1;
      var bNormalized = bPreferredIndex + 1;
      return bNormalized - aNormalized;
    }

    var aName = a.name.split(' ')[1] || '';
    var bName = b.name.split(' ')[1] || '';
    return aName.localeCompare(bName);
  };
};

var getLabel = function getLabel(countryCode, isCountryFullNameDisplayed, labelOverride) {
  return isCountryFullNameDisplayed ? "+".concat(_constants.COUNTRY_CODE_TO_DIALCODE[countryCode], " ").concat(labelOverride && labelOverride[countryCode] || _designLanguage.CountryCodeToCountryNames[countryCode]) : "+".concat(_constants.COUNTRY_CODE_TO_DIALCODE[countryCode], " (").concat(countryCode, ")");
};

var formatSelectorOptions = function formatSelectorOptions(_ref) {
  var countryCodes = _ref.countryCodes,
      labelOverride = _ref.labelOverride,
      isCountryFullNameDisplayed = _ref.isCountryFullNameDisplayed,
      areCountriesLocaleSorted = _ref.areCountriesLocaleSorted,
      preferredCountryCodes = _ref.preferredCountryCodes;
  var opts = countryCodes.map(function (code) {
    return {
      name: getLabel(code, isCountryFullNameDisplayed, labelOverride),
      value: code
    };
  });
  return areCountriesLocaleSorted ? opts.sort(nameLocaleSorter(preferredCountryCodes)) : opts;
};

exports.formatSelectorOptions = formatSelectorOptions;